export default class DynamicCallService {
  constructor(axios) {
    this.axios = axios
  }

  /**
   * @param {string} endpoint
   * @param {object} query
   */
  async list(endpoint, query) {
    const { data: { data } } = await this.axios.get(endpoint, { params: query })
    return data
  }
}
